export default __webpack_public_path__ + "static/kg-d41069c2f7046b767ff7b9782f42a35a.svg";